export type RadioTrueFalseString = 'true' | 'false';

/** Utility for converting between `string` and `boolean` types for ease of use in radio buttons.
 *
 *  Needed because DOM Radio buttons' `value` type can only be string,
 *  but its often useful to model `yes/no` variants with a Radio button. */
export const RadioConvertUtils = {
  true: 'true',
  false: 'false',
  strToBool: (str?: RadioTrueFalseString) => str === 'true',
  boolToStr(bool?: boolean): RadioTrueFalseString {
    if (bool == null) {
      return 'false';
    }

    return bool ? 'true' : 'false';
  },
};
